import React from 'react';

const cookieTypes = [
  { name: 'Nødvendige', desc: 'Autentisering, sikkerhet, grunnleggende funksjonalitet', duration: 'Sesjon / 30 dager', required: true },
  { name: 'Funksjonelle', desc: 'Brukerpreferanser, språkinnstillinger, kartinnstillinger', duration: '1 år', required: false },
  { name: 'Analytiske', desc: 'Google Analytics, ytelsesmåling, feilsporing', duration: '2 år', required: false },
  { name: 'Markedsføring', desc: 'Retargeting, konverteringssporing, personaliserte annonser', duration: '1 år', required: false },
];

const retentionPeriods = [
  { category: 'Kontodata', period: 'Til konto slettes + 30 dager', basis: 'Kontraktsoppfyllelse' },
  { category: 'Transaksjonsdata', period: '5 år', basis: 'Regnskapsloven § 13' },
  { category: 'Kommunikasjonslogg', period: '3 år', basis: 'Berettiget interesse' },
  { category: 'Analytikkdata', period: '26 måneder', basis: 'Samtykke' },
  { category: 'Sikkerhetskopier', period: '90 dager', basis: 'Berettiget interesse' },
  { category: 'Markedsføringsdata', period: 'Til samtykke trekkes tilbake', basis: 'Samtykke' },
];

const CookiesRetentionSection = () => {
  return (
    <>
      {/* Cookies */}
      <section id="informasjonskapsler" style={{ marginBottom: '80px' }}>
        <div style={{ marginBottom: '40px', position: 'relative' }}>
          <div
            style={{
              fontFamily: 'Impact, sans-serif',
              fontSize: 'clamp(4rem, 10vw, 8rem)',
              fontWeight: 900,
              color: 'rgba(59,111,212,0.06)',
              lineHeight: 1,
              position: 'absolute',
              top: '-20px',
              left: '-10px',
              userSelect: 'none',
              letterSpacing: '-0.04em'
            }}
          >
            06
          </div>
          <div style={{ position: 'relative', zIndex: 1 }}>
            <div
              style={{
                fontFamily: 'JetBrains Mono, monospace',
                fontSize: '0.6875rem',
                color: '#F97316',
                letterSpacing: '0.15em',
                textTransform: 'uppercase',
                marginBottom: '8px'
              }}
            >
              § 6 — INFORMASJONSKAPSLER
            </div>
            <h2
              style={{
                fontFamily: 'Impact, sans-serif',
                fontSize: 'clamp(1.75rem, 4vw, 3rem)',
                fontWeight: 900,
                color: '#EEF0F2',
                textTransform: 'uppercase',
                letterSpacing: '-0.02em',
                lineHeight: 1
              }}
            >
              Informasjonskapsler (Cookies)
            </h2>
          </div>
        </div>

        <p
          style={{
            fontFamily: 'Georgia, serif',
            fontSize: '1.0625rem',
            color: 'rgba(238,240,242,0.7)',
            lineHeight: 1.8,
            marginBottom: '32px',
            maxWidth: '720px'
          }}
        >
          Vi bruker informasjonskapsler og lignende teknologier for å forbedre din opplevelse. 
          Du kan administrere dine preferanser via nettleserinnstillingene eller vår 
          samtykkeplattform.
        </p>

        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ borderBottom: '2px solid rgba(59,111,212,0.3)' }}>
                {['Type', 'Beskrivelse', 'Varighet', 'Nødvendig']?.map((h) => (
                  <th
                    key={h}
                    style={{
                      fontFamily: 'Syne, sans-serif',
                      fontSize: '0.75rem',
                      fontWeight: 700,
                      color: '#3B6FD4',
                      letterSpacing: '0.08em',
                      textTransform: 'uppercase',
                      padding: '12px 16px',
                      textAlign: 'left'
                    }}
                  >
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {cookieTypes?.map((c, i) => (
                <tr
                  key={i}
                  style={{
                    borderBottom: '1px solid rgba(255,255,255,0.04)',
                    background: i % 2 === 0 ? 'rgba(255,255,255,0.01)' : 'transparent'
                  }}
                >
                  <td style={{ padding: '14px 16px', fontFamily: 'Syne, sans-serif', fontSize: '0.875rem', fontWeight: 700, color: '#EEF0F2' }}>{c?.name}</td>
                  <td style={{ padding: '14px 16px', fontFamily: 'Inter, sans-serif', fontSize: '0.8125rem', color: 'rgba(138,149,163,0.75)' }}>{c?.desc}</td>
                  <td style={{ padding: '14px 16px', fontFamily: 'JetBrains Mono, monospace', fontSize: '0.75rem', color: 'rgba(138,149,163,0.6)' }}>{c?.duration}</td>
                  <td style={{ padding: '14px 16px' }}>
                    <span
                      style={{
                        fontFamily: 'JetBrains Mono, monospace',
                        fontSize: '0.625rem',
                        color: c?.required ? '#10B981' : '#F97316',
                        background: c?.required ? 'rgba(16,185,129,0.1)' : 'rgba(249,115,22,0.1)',
                        border: `1px solid ${c?.required ? 'rgba(16,185,129,0.2)' : 'rgba(249,115,22,0.2)'}`,
                        padding: '3px 8px',
                        letterSpacing: '0.08em'
                      }}
                    >
                      {c?.required ? 'JA' : 'NEI'}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
      {/* Retention */}
      <section id="oppbevaring" style={{ marginBottom: '80px' }}>
        <div style={{ marginBottom: '40px', position: 'relative' }}>
          <div
            style={{
              fontFamily: 'Impact, sans-serif',
              fontSize: 'clamp(4rem, 10vw, 8rem)',
              fontWeight: 900,
              color: 'rgba(249,115,22,0.05)',
              lineHeight: 1,
              position: 'absolute',
              top: '-20px',
              left: '-10px',
              userSelect: 'none',
              letterSpacing: '-0.04em'
            }}
          >
            07
          </div>
          <div style={{ position: 'relative', zIndex: 1 }}>
            <div
              style={{
                fontFamily: 'JetBrains Mono, monospace',
                fontSize: '0.6875rem',
                color: '#F97316',
                letterSpacing: '0.15em',
                textTransform: 'uppercase',
                marginBottom: '8px'
              }}
            >
              § 7 — OPPBEVARINGSTID
            </div>
            <h2
              style={{
                fontFamily: 'Impact, sans-serif',
                fontSize: 'clamp(1.75rem, 4vw, 3rem)',
                fontWeight: 900,
                color: '#EEF0F2',
                textTransform: 'uppercase',
                letterSpacing: '-0.02em',
                lineHeight: 1
              }}
            >
              Oppbevaringsperioder
            </h2>
          </div>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '12px' }}>
          {retentionPeriods?.map((r, i) => (
            <div
              key={i}
              style={{
                background: 'rgba(255,255,255,0.02)',
                border: '1px solid rgba(255,255,255,0.06)',
                padding: '20px',
                display: 'flex',
                flexDirection: 'column',
                gap: '8px'
              }}
            >
              <div style={{ fontFamily: 'Syne, sans-serif', fontSize: '0.9375rem', fontWeight: 700, color: '#EEF0F2' }}>{r?.category}</div>
              <div style={{ fontFamily: 'JetBrains Mono, monospace', fontSize: '0.8125rem', color: '#3B6FD4' }}>{r?.period}</div>
              <div style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.75rem', color: 'rgba(138,149,163,0.5)' }}>{r?.basis}</div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default CookiesRetentionSection;
